import * as constants from '../config/constants';

export const mouseOverDashboard = (data) => {
  return {
    type: constants.MOUSE_OVER_DASHBOARD,
    data
  };
};
export const switchUXPath = (data) => {
  return {
    type: constants.SWITCH_UX_PATH,
    data
  };
};



// WEBPACK FOOTER //
// ./src/actions/ui.js